import { KustomerMain, KustomerMainWindow } from 'core/types';

export const chunk = <T>(arr: T[], chunkSize = 1, cache: T[][] = []) => {
  const tmp = [...arr];
  if (chunkSize <= 0) return cache;
  while (tmp.length) cache.push(tmp.splice(0, chunkSize));
  return cache;
};

export const intersection = (arr, ...args) =>
  arr.filter((item) => args.every((arr) => arr.includes(item)));

export const isString = (str) => typeof str === 'string';

export const getKustomerMainObject = (): KustomerMain => {
  const kustomerCoreWindow: KustomerMainWindow = window;

  if (!kustomerCoreWindow || !kustomerCoreWindow.KustomerMain)
    throw Error('KustomerMain object not found');

  return kustomerCoreWindow.KustomerMain;
};
